import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';


function Header({ children, theme }) {
  const {
    controls: {
      vikontReadMore: {
        title: {
          font,
          color,
          textTransform,
          letterSpacing,
          marginBottom,
          textAlign,
        },
      },
    },
  } = theme;

  return (
    <div className='title'>
      <style jsx>{`
        .title
          font ${font}
          color ${color}
          text-transform ${textTransform}
          letter-spacing ${letterSpacing}
          margin-bottom ${marginBottom}
          text-align ${textAlign}
      `}</style>
      {children}
    </div>
  );
}

Header.propTypes = {
  theme: themePropTypes(`{
    controls: {
      vikontReadMore: {
        title: {
          font,
          color,
          textTransform,
          letterSpacing,
          marginBottom,
          textAlign,
        }
      }
    },
  }`),
};

export default withTheme(Header);
